module.exports = __webpack_public_path__ + "img/friends3.c3b2505.svg";